import type { PhieuXuatDieuChuyenChiTiet, PhieuXuatDieuChuyenPasteConfigs } from '@/types/schemas';
import { type DataTableColumn, usePasteConfig } from '@/components/custom/erp';

interface UseDetailPasteProps {
  columns: DataTableColumn<PhieuXuatDieuChuyenChiTiet>[];
  handleUpdateNonWritableFields?: (fields: Set<string>) => void;
  handleUpdatePasteConfigs?: (configs: PhieuXuatDieuChuyenPasteConfigs) => void;
}

export const useDetailPaste = ({
  columns,
  handleUpdateNonWritableFields,
  handleUpdatePasteConfigs
}: UseDetailPasteProps) => {
  return usePasteConfig({
    columns,
    onNonWritableFields: handleUpdateNonWritableFields,
    onPasteConfigs: handleUpdatePasteConfigs
  });
};
